import { render, staticRenderFns } from "./PayClientReferral.vue?vue&type=template&id=ee138ff4&"
import script from "./PayClientReferral.vue?vue&type=script&lang=js&"
export * from "./PayClientReferral.vue?vue&type=script&lang=js&"
import style0 from "./PayClientReferral.vue?vue&type=style&index=0&id=ee138ff4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports